import React from 'react';
import type { ThreadLista } from '../api/types';
import FiltriProblemi from './FiltriProblemi';
import TabellaProblemi, { SHORTLIST_COLUMNS } from './TabellaProblemi';

interface Props {
  esclusi: ThreadLista[];
  lista_problemi: number[];
  setOrdineAndNotify: (ordine: string) => void;
}

const ProblemiEsclusiShortlist = ({ esclusi, lista_problemi, setOrdineAndNotify }: Props) => (
  <FiltriProblemi threads={esclusi}>
    {filtered => <TabellaProblemi threads={filtered} columns={['tipo', ...SHORTLIST_COLUMNS]} ratings="visible"
      actionColumn={{ header: 'Aggiungi', render: thread => (
        <button type="button" className="btn btn-success" title="Aggiungi il problema alla lista dei papabili"
          aria-label={`Aggiungi problema ${thread.id}`} onClick={() => {
            if (!lista_problemi.includes(thread.id)) setOrdineAndNotify([...lista_problemi, thread.id].join(','));
          }}><i className="fa fa-check" aria-hidden="true" /></button>
      ) }} />}
  </FiltriProblemi>
);

export default ProblemiEsclusiShortlist;
